import { setCookie, getCookie } from './shared/cookieHelper';
const listNLockVideoGenerationTimeout = 300; //in seconds

//function setCookie(cname, cvalue, exdays) {
//    var d = new Date();
//    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//    var expires = "expires=" + d.toUTCString();
//    document.cookie = cname + "=" + cvalue + ";path=/";
//}

//function getCookie(cname) {
//    var name = cname + "=";
//    var ca = document.cookie.split(';');
//    for (var i = 0; i < ca.length; i++) {
//        var c = ca[i];
//        while (c.charAt(0) == ' ') {
//            c = c.substring(1);
//        }
//        if (c.indexOf(name) == 0) {
//            return c.substring(name.length, c.length);
//        }
//    }
//    return "";
//}

window.showImagePopupSearchResultPage = function (ele,transformation) {
    $("#myModalSearchRateResult").modal('show');

    var modalImg = document.getElementById("img01");

    modalImg.src = ele.src.replace("/upload", "/upload/" + transformation +"/");
}
window.showTerms = function (element) {
   
    $('#terms-text').html(element);
    $('#modal-terms').show();
}

window.copyToClipboard = function (element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
    alert("Copied");
}

window.GinitMap2 = function () {
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
    };
    var input = document.getElementById('autocomplete');
    var countries = 'us';

    var autocomplete = new google.maps.places.Autocomplete(input);

    // Set initial restrict to the greater list of countries.
    autocomplete.setComponentRestrictions( { 'country': ['us'] });

    // Specify only the data fields that are needed.
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
   
    autocomplete.addListener('place_changed', function () {   

        ListNLockClearHomePage();
        var place = autocomplete.getPlace();
        if (!place.geometry) {

            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
                
        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
        }
        //for (var component in componentForm) {
        //    document.getElementById(component).value = '';
        //}

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var val = place.address_components[i][componentForm[addressType]];
                document.getElementById(addressType).value = val;
            }
        }

        if ($('#locknlist_home_page').length) {
            getstatedetails();
        }
        else {
            $('#address_form_error').addClass('d-none');
        }
    });
}

window.getstatedetails = function () {
    var street = document.getElementById('street_number').value;
    var route = document.getElementById('route').value;
    street = street + " " + route;
    street = street.replace(/ /g, "+");
    var city = document.getElementById('locality').value;
    var state = document.getElementById('administrative_area_level_1').value;
    var countyName = document.getElementById('administrative_area_level_2').value;
    var country = document.getElementById('country').value;
    var zip = document.getElementById('postal_code').value;
    if (street == '' || route == '' || city == '' || state == '' || zip == '') {
        ListNLockClearHomePage();
        setCookie("ll_lock_address_error", "yes", 1);
        //alert("Input address is not complete. Please enter the correct one.")
        return;
    }
    var StateCode;
    var CountyCode;
    var url = state == 'CT' || state == 'ct' 
        ? "https://geocoding.geo.census.gov/geocoder/geographies/address?street=" + street + "&city=" + city + "&state=" + state + "&benchmark=Public_AR_Current&vintage=Census2020_Current&layers=10&format=json&callback=?"        
        : "https://geocoding.geo.census.gov/geocoder/geographies/address?street=" + street + "&city=" + city + "&state=" + state + "&benchmark=Public_AR_Current&vintage=Current_Current&layers=10&format=json&callback=?";
        
    try {
        $.getJSON(url, function (data, textStatus) {
            if (data.result.addressMatches.length) {
                StateCode = state == 'CT' || state == 'ct' ? data.result.addressMatches[0].geographies['Census Blocks'][0].STATE : data.result.addressMatches[0].geographies['Census Block Groups'][0].STATE;
                CountyCode = state == 'CT' || state == 'ct' ? data.result.addressMatches[0].geographies['Census Blocks'][0].COUNTY : data.result.addressMatches[0].geographies['Census Block Groups'][0].COUNTY;
                document.getElementById('state_code').value = StateCode;
                document.getElementById('county_code').value = CountyCode;
                $("#btnStarted").removeAttr("disabled");
                $("#btnStarted").removeClass("disabled");
                $("#btnStartedMob").removeAttr("disabled");
                $("#btnStartedMob").removeClass("disabled");
            }
            else {
                $.getJSON(`geo-codes?state=${state}&countyName=${countyName}`, function (data, textStatus) {
                    var codes = JSON.parse(data);
                    if (codes) {
                        document.getElementById('state_code').value = codes.stateCode;
                        document.getElementById('county_code').value = codes.countyCode;
                        $("#btnStarted").removeAttr("disabled");
                        $("#btnStarted").removeClass("disabled");
                        $("#btnStartedMob").removeAttr("disabled");
                        $("#btnStartedMob").removeClass("disabled");
                    }                    
                })
            }            
        }).fail(function () {
            $.getJSON(`geo-codes?state=${state}&countyName=${countyName}`, function (data, textStatus) {
                var codes = JSON.parse(data);
                if (codes) {
                    document.getElementById('state_code').value = codes.stateCode;
                    document.getElementById('county_code').value = codes.countyCode;
                    $("#btnStarted").removeAttr("disabled");
                    $("#btnStarted").removeClass("disabled");
                    $("#btnStartedMob").removeAttr("disabled");
                    $("#btnStartedMob").removeClass("disabled");
                }
            })
        });
    }
    catch (error) {
        console.error(error);
        ListNLockClearHomePage();
        setCookie("ll_lock_address_error", "yes", 1);
        //alert("Unable to verify the input address. Please enter the correct one.")
        return;
    }       
}

window.ListNLockClearHomePage = function () {
    $('#street_number').val('');
    $('#route').val('');
    $('#locality').val('');
    $('#administrative_area_level_1').val('');
    $('#country').val('');
    $('#postal_code').val('');
    $('#state_code').val('');
    $('#county_code').val('');
    $("#btnStarted").attr("disabled", "disabled");
    $("#btnStarted").addClass("disabled");
    $("#btnStartedMob").attr("disabled", "disabled");
    $("#btnStartedMob").addClass("disabled");
};

window.GetDataFromModal = function () {
    $('#street_number').val($('#txtStreetNo').val());
    $('#route').val($('#txtStreet').val());
    $('#locality').val($('#txtCity').val());    
    $('#postal_code').val($('#txtZip').val());
   
};
window.thisFileUpload = function () {
    document.getElementById("listingimagefile").click();
};

$(function () {

    if ($('#locknlist_home_page').length) {
        var $loading = $('#ll_loading-div').hide();
        var $loadingform = $('#ll_loading-div-form').hide();

        $('#autocomplete').bind("cut copy paste", function (e) {
            e.preventDefault();
        });

        $('#autocomplete').bind("change", function (e) {
            ListNLockClearHomePage();
        });

        $('#selectState').on('change', function (e) {
            var optionSelected = $("option:selected", this);            
            var stateCode = optionSelected.text()
            document.getElementById('state_code').value = this.value;
            $('#administrative_area_level_1').val(stateCode);
            var loc = $("#prefixurl").val();
            //var form = new FormData();
            //form.append("formstate", stateCode);

            $.ajax({
                url: loc + '/get-counties/' + stateCode,
                type: 'GET',
                //cache: false,
                //contentType: false,
                //processData: false,
                //data: form,
                beforeSend: function () {
                    $loadingform.show();
                },
                success: function (response) {
                    $loadingform.hide();
                    let dropdown = document.getElementById('selectCounty');
                    dropdown.length = 0;

                    let defaultOption = document.createElement('option');
                    defaultOption.text = 'Choose County';

                    dropdown.add(defaultOption);
                    dropdown.selectedIndex = 0;
                    var obj = jQuery.parseJSON(response);
                    let option;

                    for (let i = 0; i < obj.length; i++) {
                        option = document.createElement('option');
                        option.text = obj[i].Name;
                        option.value = obj[i].Code;
                        dropdown.add(option);
                    }
                }
            });                      
        });

        $('#selectCounty').on('change', function (e) {
            var optionSelected = $("option:selected", this);
            var valueSelected = this.value;
            var textSelected = optionSelected.text()
            document.getElementById('county_code').value = this.value;
            $('#administrative_area_level_2').val(textSelected);

        });

        $('#btnFormStart').click(function (e) {

            $("#modaladdress_ll").validate();
            if ($('#modaladdress_ll').valid()) {
                e.preventDefault();
                GetDataFromModal();
                //getstatedetailsmanual();
                var form = new FormData();
                setCookie("ll_state_error", "no", 1);
                form.append("autocomplete", document.getElementById('autocomplete').value);
                form.append("state_code", document.getElementById('state_code').value);
                form.append("county_code", document.getElementById('county_code').value);
                form.append("locality", document.getElementById('locality').value);
                form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
                var s = $("#administrative_area_level_1").val();
                form.append("state_lisenced", $("#state_lisenced").val());
                var sl = $("#state_lisenced").val();
                form.append("member_id", $("#member_id").val());
                form.append("street_number", $("#street_number").val());
                form.append("route", $("#route").val());
                form.append("postal_code", $("#postal_code").val());
                form.append("branch_orgid", $("#branch_orgid").val());
                var loc = $("#prefixurl").val();
                setCookie("ll_prefix_url", loc, 1);
                setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
                if (sl.indexOf(s) < 0) {
                    setCookie("ll_state", s, 1);
                    setCookie("ll_state_error", "yes", 1);
                    window.location.href = loc;
                }
                else {
                    $.ajax({
                        url: loc + '/RateOptions',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $loading.show();
                        },
                        success: function (response) {
                            $loading.hide();
                            if (response == "ok")
                                window.location.href = loc + "/SearchRateOptions";
                            else
                                window.location.href = loc;
                        }
                    });
                }
            }
            else
                return false;
        });

        $("#btnStarted").attr("disabled", "disabled");
        $("#btnStarted").addClass("disabled");
        $("#btnStartedMob").attr("disabled", "disabled");
        $("#btnStartedMob").addClass("disabled");
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
        script.async = true;
        document.body.appendChild(script);
      
        $('#btnStartedMob').click(function (e) {
            e.preventDefault();
            var form = new FormData();
            setCookie("ll_state_error", "no", 1);
            form.append("autocomplete", document.getElementById('autocomplete').value);
            form.append("state_code", document.getElementById('state_code').value);
            form.append("county_code", document.getElementById('county_code').value);
            form.append("locality", document.getElementById('locality').value);
            form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
            var s = $("#administrative_area_level_1").val();
            form.append("state_lisenced", $("#state_lisenced").val());
            var sl = $("#state_lisenced").val();
            form.append("member_id", $("#member_id").val());
            form.append("street_number", $("#street_number").val());
            form.append("route", $("#route").val());
            form.append("postal_code", $("#postal_code").val());
            form.append("branch_orgid", $("#branch_orgid").val());
            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
            if (sl.indexOf(s) < 0) {
                setCookie("ll_state", s, 1);
                setCookie("ll_state_error", "yes", 1);
                window.location.href = loc;
            }
            else {
                $.ajax({
                    url: loc + '/RateOptions',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response == "ok")
                            window.location.href = loc + "/SearchRateOptions";
                        else
                            window.location.href = loc;
                    }
                });
            }
        });

        $('#btnStarted').click(function (e) {
            e.preventDefault();
            var form = new FormData();
            setCookie("ll_state_error", "no", 1);
            form.append("autocomplete", document.getElementById('autocomplete').value);
            form.append("state_code", document.getElementById('state_code').value);
            form.append("county_code", document.getElementById('county_code').value);
            form.append("locality", document.getElementById('locality').value);
            form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
            var s = $("#administrative_area_level_1").val();
            form.append("state_lisenced", $("#state_lisenced").val());
            var sl = $("#state_lisenced").val();
            form.append("member_id", $("#member_id").val());
            form.append("street_number", $("#street_number").val());
            form.append("route", $("#route").val());
            form.append("postal_code", $("#postal_code").val());
            form.append("branch_orgid", $("#branch_orgid").val());
            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
            if (sl.indexOf(s) < 0) {
                setCookie("ll_state", s, 1);
                setCookie("ll_state_error", "yes", 1);
                window.location.href = loc;
            }
            else {
                $.ajax({
                    url: loc + '/RateOptions',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response == "ok")
                            window.location.href = loc + "/SearchRateOptions";
                        else
                            window.location.href = loc;
                    }
                });
            }
        });

        $('#modal-confirmation').keypress(function (e) {
            if (e.keyCode == 13) {
                $('#btnConfirm').click();
            }
        });

        $('#btnConfirm').on('click',function (e) {
            e.preventDefault();
           
            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);

           
                $.ajax({
                    url: loc + '/check?id=' + $("#txtConfirmationNumber").val(),
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $loading.show();
                    },
                    data: "",
                    success: function (response) {
                        console.log(JSON.stringify(response));

                        $loading.hide();
                        if (response.success)
                            window.location.href = response.redirectUrl
                    }
                });
            
        });

        $('#btnResent').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            var formData = new FormData();
            formData.append("resentemail", $("#txtREmail").val());
            $.ajax({
                url: loc + '/CheckAndResend',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/information?status=ok';
                    }
                    else {
                        window.location.href = loc + '/information?status=error';
                    }
                }
            });

        });

        $('#btnAlreadyExist').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            
            $.ajax({
                url: loc + '/AlreadyExist',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/SearchRateOptions';
                    }
                    //else {
                    //    window.location.href = loc + '/information?status=error';
                    //}
                }
            });

        });
    }

    if ($('#search_rate_options_page').length) {
        var $loading = $('#ll_loading-div');

        $(document).ready(function () {
            $loading.hide();
            document.getElementById("hdnNoOfUnits").value = 1;
            $('select').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                document.getElementById("hdnNoOfUnits").value = this.value;
            });
        });
        $('#multi').change(function () {
            if (this.checked) {
                $('#div-multi').css("display", "block");
                document.getElementById("noUnits").attr('required', '');
            } else {
                $('#div-multi').css("display", "none");
                $("#noUnits").removeAttr('required');
                document.getElementById("hdnNoOfUnits").value = 1;
            }
        });
        
        $('#btnSearch').click(function (e) {
            e.preventDefault();
            if ($('#search-form').valid()) {

                if ($('#multi').is(":checked")) {
                    var n = document.getElementById("hdnNoOfUnits").value;
                    if (n < 2) {
                        alert("Please select the No. of Units");
                        return false;
                    }
                }
                var form = new FormData();

                form.append("sellerconcession", document.getElementById('sellerinput').value);
                form.append("salesprice", document.getElementById('salesinput').value);
                //alert(document.getElementById('hdnNoOfUnits').value);
                form.append("noUnits", document.getElementById('hdnNoOfUnits').value);
                //form.append("noUnits", $("#noUnits option:selected").text());  
                
                form.append("propertytype", $("input:radio[name='propertytype']:checked").val());
                form.append("contribution_cmg", document.getElementById('contribution_CMG').value);
                //form.append("contribution_agent", document.getElementById('contribution_Agent').value);
                form.append("contribution_agent", "0.00");
                var loc1 = getCookie("ll_prefix_url");
                $.ajax({
                    url: loc1 + '/get-rate-options',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                       
                        if (response == "ok") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else if (response == "nodata") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else {
                            window.location.href = loc1;
                        }
                    }
                });
            }
            else
                return false;

        });              
    }
      
    if ($('#search_rate_result_page').length) {
        $(document).ready(function () {



            var slider = document.getElementById('slider'),
                sliderItems = document.getElementById('slides'),
                prev = document.getElementById('prev'),
                next = document.getElementById('next');

            function slide(wrapper, items, prev, next) {
                var posX1 = 0,
                    posX2 = 0,
                    posInitial,
                    posFinal,
                    threshold = 100,
                    slides = items.getElementsByClassName('slide'),
                    slidesLength = slides.length,
                    slideSize = items.getElementsByClassName('slide')[0].offsetWidth,
                    index = 0,
                    allowShift = true;

                wrapper.classList.add('loaded');



                function appendAfter(n, original, appendTo) {
                    for (var i = 0; i < n; i++) {
                        var clone = original[i].cloneNode(true);
                        appendTo.appendChild(clone);
                    }
                }
                // appendAfter(5, slides, items);

                //  items.insertBefore(slides[slidesLength - 1].cloneNode(true), slides[0]);

                // Mouse events
                //   items.onmousedown = dragStart;

                //   // Touch events
                //   items.addEventListener('touchstart', dragStart);
                //   items.addEventListener('touchend', dragEnd);
                //   items.addEventListener('touchmove', dragAction);

                // Click events
                prev.addEventListener('click', function () { shiftSlide(-1) });
                next.addEventListener('click', function () { shiftSlide(1) });

                // Transition events
                items.addEventListener('transitionend', checkIndex);

                function dragStart(e) {
                    e = e || window.event;
                    e.preventDefault();
                    posInitial = items.offsetLeft;

                    if (e.type == 'touchstart') {
                        posX1 = e.touches[0].clientX;
                    } else {
                        posX1 = e.clientX;
                        document.onmouseup = dragEnd;
                        document.onmousemove = dragAction;
                    }
                }

                function dragAction(e) {
                    e = e || window.event;

                    if (e.type == 'touchmove') {
                        posX2 = posX1 - e.touches[0].clientX;
                        posX1 = e.touches[0].clientX;
                    } else {
                        posX2 = posX1 - e.clientX;
                        posX1 = e.clientX;
                    }
                    items.style.left = (items.offsetLeft - posX2) + "px";
                }

                function dragEnd(e) {
                    posFinal = items.offsetLeft;
                    if (posFinal - posInitial < -threshold) {
                        shiftSlide(1, 'drag');
                    } else if (posFinal - posInitial > threshold) {
                        shiftSlide(-1, 'drag');
                    } else {
                        items.style.left = (posInitial) + "px";
                    }

                    document.onmouseup = null;
                    document.onmousemove = null;
                }

                function shiftSlide(dir, action) {
                    items.classList.add('shifting');

                    if (allowShift) {
                        if (!action) { posInitial = items.offsetLeft; }

                        if (dir == 1) {
                            items.style.left = (posInitial - slideSize) + "px";
                            index++;
                        } else if (dir == -1) {
                            items.style.left = (posInitial + slideSize) + "px";
                            index--;
                        }

                    };

                    allowShift = false;
                }

                function checkIndex() {
                    items.classList.remove('shifting');

                    if (index == -1) {
                        items.style.left = -(slidesLength * slideSize) + "px";
                        index = slidesLength - 1;
                    }

                    if (index == slidesLength) {
                        items.style.left = -(1 * slideSize) + "px";
                        index = 0;
                    }
                    allowShift = true;
                }
            }

            slide(slider, sliderItems, prev, next);

            var $loading = $('#ll_loading-div').hide();
            var loc1 = getCookie("ll_prefix_url");

            $("#myModalSearchRateResult").modal('hide');       
        
            $.ajax({
                url: loc1 + '/generate-flyer-background',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                   // $loading.show();
                   // $("#openimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                },
                success: function (response) {

                    if (response != "") {
                        //$("#openlink").attr("href", response.replace("/upload/", "/upload/a_320,g_center,l_text:Arial_180_bold:Sample,e_colorize,o_50,z_2,co_rgb:f20e0e/"));
                        //$("#openimg").attr("src", response.replace("/upload/", "/upload/a_320,g_center,l_text:Arial_200_bold:Sample,e_colorize,o_50,z_2,co_rgb:f20e0e/").replace(".pdf", ".png"));
                    }
                  
                }
            });

         
            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle = "popover"]').popover({
                html: true,
                title: 'Repayment' + genericCloseBtnHtml,
                content: function () {
               return $(this).next('.popper-content').html();
            }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });
            $('[data-toggle="tooltip"]').tooltip();
        });
      
        
    }

    if ($('#ll_property_page').length) {
               
        $(function () {

            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle="popover"]').popover({
                html: true,               
                content: function () {
                    return $(this).next('.popper-content').html();
                }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });

            $('[data-toggle="tooltip"]').tooltip();

            if ($('#property_video').is('.pending')) {
                var propertyVideoCounter = 0;

                var cTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=property")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;

                                //customized video                                
                                var thumbnailUrl = $('#property_video [data-role="thumbnail"]').attr('data-src');
                                $('#property_video [data-role="thumbnail"]').css('background-image', `url(${thumbnailUrl}`);
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);

                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');                               
                                new VideoPlayer();                                                              
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoCounter++;

                            if (propertyVideoCounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                            }
                        });
                }, 1000);
            }

            if ($('#ll_property_page').data('collaterals-refresh')) {
                var form = new FormData();
                form.append("loan-number", $("#hdnConfirmationNumber").val());

                $.ajax({
                    url: $("#prefixurl").val() + '/generate-flyer-confirmation',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {

                        if (response != "") {
                            $("#openFlyerBtn a").attr("href", response);
                            $("#openFlyerBtn").removeClass("d-none");
                        }
                    }
                });
            }           
        });
    }

    if ($('#locknlist_esign_page').length) {
        $('iframe').on('load', function () {
            $('iframe').contents().find("head")
                .append($("<style type='text/css'> #welcome-wrapper{display:none;}  </style>"));
        });
    }

    if ($('#locknlist_payment_success').length) {
        var returnUrl = $('#locknlist_payment_success').data('url');

        createLoan(returnUrl, 0);
    }

    if ($('#locknlist_presentation_page').length) {

        var page1Url = $('#hdnUrl1').val();
        var page2Url = $('#hdnUrl2').val();
        var presentationUrl = $('#hdnUrl').val();
        if (presentationUrl.length > 0 && presentationUrl != "Pending") {
            $("#pdfimg").attr("src", page1Url);
            retrun;
        }
            
        var $loading = $('#ll_loading-div').hide();
        $("#pdfimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");

        if (page1Url.length === 0) {
            $.post('generate-presentationpage1-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl1').val(data);
                })
                .fail(function (xhr, status, error) {                    
                    console.log($`Error in generate-presentationpage1-background. Xhr: ${JSON.stringify(xhr)} status: ${status} error: ${error}`);
                });
        }

        if (page2Url.length === 0) {
            $.post('generate-presentationpage2-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl2').val(data);
                })
                .fail(function (xhr, status, error) {
                    console.log($`Error in generate-presentationpage2-background. Xhr: ${JSON.stringify(xhr)} status: ${status} error: ${error}`);
                });
        }

        if ($('#merge_pdf').is('.pending')) {
            var pdfCounter = 0;
            var id = $('#hdnID').val();
            var cTimer = setInterval(() => {
                $.get("/list-n-lock/pdf-upload-status?id=" + $('#hdnID').val() + "&type=presentation")
                    .done(function (data, textStatus, jqXHR) {
                        if (data.pdfUrl && data.pdfUrl.length > 0) {
                            pdfCounter = 90;
                            $('#instructions-div').addClass('d-none');
                            $('.heading-row').removeClass('d-none');
                            $('#merge_pdf').removeClass('pending');
                            $('#pdflink').attr('href', data.pdfFile);
                            $("#pdfimg").attr("src", data.previewURL);
                        }
                    })
                    .fail(function (xhr, status, error) {
                        console.log($`Error in pdf-upload-status request. Xhr: ${JSON.stringify(xhr)} status: ${status} error: ${error}`);
                        pdfCounter = 90;
                    })
                    .always(function () {
                        pdfCounter++;

                        if (pdfCounter > 90) {
                            $('#instructions-div p').text('Unable to generate presentation file. Please try again.').addClass('upload-error');
                            clearInterval(cTimer);
                        }
                    });
            }, 2000);
        }       
    }
});

function createLoan(url, retryAttempt) {

    $.post(url)
        .done(function (data) {
            if (data.success) {
                console.log('redirecting to ' + data.redirectUrl);
                window.location.href = data.redirectUrl;
            }
            else {
                $('.label-error').removeClass('d-none');
                $('.dev-error h6').text(data.errorMessage);
                $('.label').addClass('d-none');
                $('img').addClass('d-none');
            }
        })
        .fail(function (xhr, status, error) {
            if (xhr.status === 503) {
                alert.log('error 503')
                retryAttempt++;
                if (retryAttempt < 4) {
                    createLoan(returnUrl, retryAttempt);
                    return;
                }
            }
          
            $('.label-error').removeClass('d-none');
            $('.dev-error h6').text(`Communication error. xhr: ${JSON.stringify(xhr)}, status: ${JSON.stringify(status)} error: ${JSON.stringify(error)}`);
            $('.label').addClass('d-none');
            $('img').addClass('d-none');
        });

    setTimeout(() => {
        location.reload();
    }, 300000);
}
